import { dependencies } from '@pn/core/dependencies';
import { useInjectableReducer as useInjectableReducerService } from '@pn/services/redux/useInjectableReducer';
import type { Reducer } from '@reduxjs/toolkit';

/**
 * IMPORTANT: only use when dealing with dynamic reducers that cannot be added
 * to the store before runtime.
 * For application-specific reducers, register them in the application-specific
 * store instead (e.g. apps/maps/src/application/storage/store.ts).
 */
export function useInjectableReducer(sliceName: string, reducer: Reducer) {
  return useInjectableReducerService(dependencies.store, sliceName, reducer);
}
